import { h } from '../lib/dom.js';

export function appShell(content) {
  return h('div', { class: 'min-h-full flex flex-col' },
    masthead(),
    h('main', { class: 'flex-1' }, content),
    colophon(),
  );
}

function masthead() {
  const currentHash = window.location.hash.replace(/^#/, '') || '/';
  const link = (href, label) => {
    const active = currentHash === href || (href !== '/' && currentHash.startsWith(href));
    return h('a', {
      href: `#${href}`,
      class: active
        ? 'text-[color:var(--color-ink)] border-b border-[color:var(--color-ink)] pb-0.5'
        : 'text-[color:var(--color-ink-soft)] hover:text-[color:var(--color-ink)] transition-colors',
    }, label);
  };

  return h('header', { class: 'border-b border-[color:var(--color-rule)]' },
    h('div', { class: 'max-w-[1200px] mx-auto px-6 md:px-10 pt-5 pb-4 flex items-baseline gap-8' },
      h('a', { href: '#/', class: 'flex items-baseline gap-3' },
        h('div', { class: 'display display-sm leading-none italic' }, 'Percy'),
        h('div', { class: 'folio' }, 'Property · Adelaide'),
      ),
      h('nav', { class: 'flex items-baseline gap-5 ml-auto text-[0.92rem]' },
        link('/feaso', 'Feasibility'),
        link('/scenarios', 'Ledger'),
        link('/finder', 'Finder'),
        link('/library', 'Library'),
      ),
    ),
  );
}

function colophon() {
  const now = new Date();
  const month = now.toLocaleDateString('en-AU', { month: 'long' });
  return h('footer', { class: 'border-t border-[color:var(--color-rule)] mt-16' },
    h('div', { class: 'max-w-[1200px] mx-auto px-6 md:px-10 py-5 flex items-baseline justify-between gap-6 folio' },
      h('div', null, `Percy Property · ${month} ${now.getFullYear()}`),
      h('div', { class: 'text-right text-[color:var(--color-ink-dim)] normal-case tracking-normal text-[0.72rem]' },
        'Indicative only. Validate with your accountant and quantity surveyor.',
      ),
    ),
  );
}
